import { action } from 'typesafe-actions';
import localStorage from 'local-storage';
import history from 'app/routes/history';
import { IPagination } from 'app/types/common';
import { StripeSessionsActionTypes as types } from './types';

/* ********************************* APP ACTIONS ********************************* */

export const createStripeSession = (data): any => action(types.CREATE_STRIPE_SESSION_REQUESTED, data);

export const updateStripeSession = (data): any => action(types.UPDATE_STRIPE_SESSION_REQUESTED, data);

export const deleteStripeSession = (stripeSessionId): any => action(types.UPDATE_STRIPE_SESSION_REQUESTED, stripeSessionId);

export const getStripeSession = (stripeSessionId): any => action(types.GET_STRIPE_SESSION_REQUESTED, stripeSessionId);

export const getAllStripeSessions = (
  pagination: IPagination = undefined,
  compile = true,
): any => action(types.GET_ALL_STRIPE_SESSIONS_REQUESTED, { pagination, compile });

export const selectStripeSession = (stripeSessionId): any => action(types.SELECT_STRIPE_SESSION_REQUESTED, {
  currentStripeSessionId: stripeSessionId,
});

/* ********************************* SAGA ACTIONS ********************************* */
export const sagaActions = {
  createStripeSessionPending: (payload): any => action(types.CREATE_STRIPE_SESSION_PENDING, payload),
  createStripeSessionSuccess: (response): any => action(types.CREATE_STRIPE_SESSION_SUCCESS, {
    stripeSessionsById: response.entities.stripeSessions,
    currentStripeSessionId: response.result,
  }),
  updateStripeSessionPending: (payload): any => action(types.UPDATE_STRIPE_SESSION_PENDING, payload),
  updateStripeSessionSuccess: (response): any => action(types.UPDATE_STRIPE_SESSION_SUCCESS, {
    stripeSessionsById: response.entities.stripeSessions,
    currentStripeSessionId: response.result,
  }),
  updateStripeSessionFailed: (error): any => action(types.UPDATE_STRIPE_SESSION_FAIL, { backendErrors: error }),
  deleteStripeSessionPending: (): any => action(types.UPDATE_STRIPE_SESSION_PENDING, {}),
  deleteStripeSessionSuccess: (response, userId): any => {
    localStorage.set(userId, { currentStripeSessionId: null });
    history.push('/stripeSessions');

    return action(types.DELETE_STRIPE_SESSION_SUCCESS, {
      currentStripeSessionId: response,
    });
  },
  getStripeSessionPending: (): any => action(types.GET_STRIPE_SESSION_PENDING, {}),
  getStripeSessionSuccess: (response): any => action(types.GET_STRIPE_SESSION_SUCCESS, {
    stripeSessionsById: response.entities.stripeSessions,
    currentStripeSessionId: response.result,
  }),
  getStripeSessionFailed: (error): any => action(types.GET_STRIPE_SESSION_FAIL, { backendErrors: error }),
  deleteStripeSessionFailed: (error): any => action(types.UPDATE_STRIPE_SESSION_FAIL, { backendErrors: error }),
  getAllStripeSessionsPending: (pagination): any => action(types.GET_ALL_STRIPE_SESSIONS_PENDING, { pagination }),
  getAllStripeSessionsSuccess: (response, meta): any => action(types.GET_ALL_STRIPE_SESSIONS_SUCCESS, {
    stripeSessionsById: response.entities.stripeSessions,
    stripeSessionIds: response.result,
    meta,
  }),
  getAllStripeSessionsFailed: (error): any => action(types.GET_ALL_STRIPE_SESSIONS_FAIL, { backendErrors: error }),
  createStripeSessionFailed: (error): any => action(types.CREATE_STRIPE_SESSION_FAIL, { backendErrors: error }),
};

export default null;
